// import { useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import HeroSection from './components/HeroSection'
import PackagesSection from './components/PackagesSection'
import Footer from './components/Footer'
import AdminDashboard from './components/AdminDashboard'

/**
 * MindGlow Luxury Portfolio - Main App Component
 * 
 * This is the main application component that orchestrates the entire luxury portfolio experience.
 * Features a cinematic 3D hero section, elegant package showcase, and minimalistic footer.
 * 
 * UX Flow:
 * 1. Hero section loads with 3D background and fade-in animations (2s total)
 * 2. User scrolls to packages section with hover effects and glow animations
 * 3. Modal form opens with scale-in animation for package inquiries
 * 4. Footer provides contact information with subtle hover effects
 * 
 * Performance Considerations:
 * - 3D scene uses React Three Fiber with optimized rendering
 * - Animations use CSS transforms for 60fps performance
 * - Lazy loading for modal component to reduce initial bundle size
 */

// Main Portfolio Component
function Portfolio() {
  return (
    <div className="min-h-screen bg-luxury-black">
      {/* Hero Section with 3D Background */}
      <HeroSection />
      
      {/* Packages Section with Luxury Cards */}
      <PackagesSection />
      
      {/* Minimalistic Footer */}
      <Footer />
    </div>
  )
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Portfolio />} />
        <Route path="/admin" element={<AdminDashboard />} />
      </Routes>
    </Router>
  )
}

export default App
